export enum CardTypeEnum {
    UNSPECIFIED = 'UNSPECIFIED',
    SHIPPER = 'SHIPPER',
    DESTINATION = 'DESTINATION',
    BROKER = 'BROKER',
    SOLD_TO = 'SOLD_TO',
    CONTACT = 'CONTACT',
    CUSTOMER = 'CUSTOMER',
    IDENTITY = 'IDENTITY',
    SETTING = 'SETTING'
}
